import { useEffect, useState } from "react";
import { ColorPickerInputProps } from "./types";

export function useColorPickerInputController({ value, defaultValue, onChange }: ColorPickerInputProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [inputValue, setInputValue] = useState(value || defaultValue || null);
  const [color, setColor] = useState(value || defaultValue || null);
  const [lastValidColor, setLastValidColor] = useState(color || null);

  useEffect(() => {
    if (value !== undefined) {
      setInputValue(value);
      setColor(value);
      setLastValidColor(value);
    }
  }, [value])

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColorChange = (newColor: string) => {
    setColor(newColor);
    setInputValue(newColor);
    setLastValidColor(newColor);
    onChange?.(newColor);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = event.target.value.trim();

    newValue = `#${newValue.replace(/[^0-9a-fA-F]/g, "").slice(0, 6)}`;

    setInputValue(newValue);

    if (/^#([0-9A-Fa-f]{6})$/i.test(newValue)) {
      setColor(newValue);
      setLastValidColor(newValue);
      onChange?.(newValue);
    } else if (newValue === "#") {
      setColor(null);
      onChange?.(null);
    }
  };

  const handleBlur = () => {
    if (inputValue && !/^#([0-9A-Fa-f]{6})$/i.test(inputValue)) {
      setInputValue(lastValidColor);
      setColor(lastValidColor);
    }
  };

  const handleClearColor = () => {
    setColor(null);
    setInputValue("");
    onChange?.(null);
  };


  return {
    color,
    anchorEl,
    inputValue,
    handleOpen,
    handleClose,
    handleColorChange,
    handleInputChange,
    handleBlur,
    handleClearColor,
  };
}
